import { render, staticRenderFns } from "./NewAndEditSecurity.vue?vue&type=template&id=85d0b196"
import script from "./NewAndEditSecurity.vue?vue&type=script&lang=js"
export * from "./NewAndEditSecurity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports